<script lang="ts" setup>
  import type { TypeGiftCardBalanceCheckerComponent } from '~/types/contentful'

  defineProps<{
    data: TypeGiftCardBalanceCheckerComponent<'WITHOUT_UNRESOLVABLE_LINKS', string>
  }>()
</script>

<template>
  <section class="m-balance-checker module-paddings">
    <CBalanceChecker
      :background-color="data.fields.base?.fields.backgroundColour"
      class="m-balance-checker__balance-checker"
    />
  </section>
</template>

<style lang="scss" scoped>
  .m-balance-checker {
    background-color: v-bind('data.fields.base?.fields.backgroundColour');

    .m-balance-checker__balance-checker {
      margin: 0 auto;
    }
  }
</style>
